export default __webpack_public_path__ + "static/media/HDTX_The Invitation of GMS 2021.6bbdee6f.pdf";